var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table-header-container px-6 px-md-6 mb-6"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }